<template>
  <div class="dateTab">

    <div class="content" ref="content">
      <div ref="contentFlex" class="contentFlex hid-scrollbar">
        <div
          :class="['item', { active: active == 'all' }]"
          data-date="all"
          @click="$emit('update:active', 'all')"
        >
          {{$t('home.All')}}
        </div>
        <div
          v-for="(item, index) in dateData"
          :key="index"
          :class="['item', { active: active == item.dateTime }]"
          :data-date="item.dateTime"
          @click="$emit('update:active', item.dateTime)"
        >
         {{ item.dateFormat }}
         {{ item.formatWeek }}
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
export default {
  name: "DateTab",
  props: ["dateData", "active"],
  watch: {
    active: {
      handler() {
        this.scrollActiveIntoView();
      },
      immediate: true,
    },
    dateData() {
      this.scrollActiveIntoView();
    },
  },
  methods: {
    scrollActiveIntoView() {
      this.$nextTick(() => {
        const scrollEl = this.$refs.contentFlex;
        const activeEl = scrollEl?.querySelector(
          `[data-date="${this.active}"]`
        );
        if (!scrollEl || !activeEl) return;
        const targetLeft =
          activeEl.offsetLeft -
          (scrollEl.clientWidth - activeEl.offsetWidth) / 2;
        scrollEl.scrollTo({
          left: Math.max(targetLeft, 0),
          behavior: "smooth",
        });
      });
    },
    sceollHandle(right) {
      let scrollLeft = this.$refs.contentFlex.scrollLeft + (right ? 97 : -97);
      this.$refs.contentFlex.scrollTo(scrollLeft, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.dateTab {
  display: flex;
  height: 38px;
  overflow: hidden;
  line-height: 38px;
  margin: 8px 8px 4px;
  .left,
  .right {
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      color: #F80000;
    }
  }
  .content {
    flex: 1;
    
    display: flex;
    overflow: hidden;
    background: #fff;
    padding: 0 6px;
    border-radius: 8px;
    color: var(--text-dark-color);
    .contentFlex {
      overflow: auto;
      white-space: nowrap;
    }
    .item {
      display: inline-block;
      padding: 0 14px;
      height: 26px;
      border-radius: 100px;
      line-height: 26px;
      width: auto;
      cursor: pointer;
  
    }
    .active {
      background: #F80000;
      color: #fff;
    }
  }
}
</style>

<style lang="scss">
.dark{
  .dateTab .content{
    background: var(--color-10);
    // color: #fff;
    .active{
      color: #fff;
    }
  }
}
</style>
